/* eslint-disable max-len */
import { createSvgIcon } from '@mui/material/utils';

export default createSvgIcon(
  <path d="M4.6 10.4c-.8 0-1.6.8-1.6 1.6s.8 1.6 1.6 1.6 1.6-.8 1.6-1.6-.8-1.6-1.6-1.6zm0-6C3.8 4.4 3 5.2 3 6s.8 1.6 1.6 1.6S6.2 6.8 6.2 6s-.8-1.6-1.6-1.6zm14.6 3.1c.8 0 1.6-.6 1.6-1.5s-.6-1.5-1.6-1.5H9c-.8 0-1.4.7-1.4 1.5s.6 1.5 1.6 1.5m10 6c.8 0 1.6-.6 1.6-1.5s-.6-1.5-1.6-1.5H9c-.8 0-1.4.8-1.4 1.5s.6 1.5 1.6 1.5m10 6c.8 0 1.6-.6 1.6-1.5s-.6-1.5-1.6-1.5H9c-.8 0-1.4.8-1.4 1.5s.6 1.5 1.6 1.5m-4.6-3.1c-.8 0-1.6.8-1.6 1.6s.8 1.6 1.6 1.6 1.6-.8 1.6-1.6-.8-1.6-1.6-1.6z"/>
, 'FormatListBulletedRounded');
